import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import DialogContent from '@mui/material/DialogContent';
import Cookies from 'js-cookie';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Switch from '@mui/material/Switch';
import styled from 'styled-components';

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;
var ConsentDialog = /*#__PURE__*/styled(Dialog)(_templateObject || (_templateObject = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  & .MuiDialogTitle-root {\n    padding: 32px 24px 0;\n  }\n\n  & .MuiDialog-paper {\n    background-color: #ffffff;\n  }\n\n  @media (min-width: 600px) {\n    & .MuiDialogTitle-root {\n      padding: 48px 56px 16px;\n    }\n\n    & .MuiDialogContent-root {\n      padding: 16px 56px 16px;\n    }\n  }\n"])));
var DialogHeading = /*#__PURE__*/styled(DialogTitle)(_templateObject2 || (_templateObject2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  color: rgb(215, 22, 235);\n  font-size: 2rem;\n  font-family: 'GT Super', serif;\n  font-weight: 300;\n  line-height: 1.6;\n  margin: 0;\n"])));
var DialogCopy = /*#__PURE__*/styled.p(_templateObject3 || (_templateObject3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  font-family: 'IBM Plex Sans', 'Helvetica Neue', Arial, sans-serif;\n  font-size: 16px;\n  margin: 16px 0;\n  color: #161710;\n"])));
var Link = /*#__PURE__*/styled.a(_templateObject4 || (_templateObject4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  color: rgb(215, 22, 235);\n\n  &:hover,\n  &:active,\n  &:visited {\n    color: rgb(215, 22, 235);\n  }\n"])));
var StackMobileActions = /*#__PURE__*/styled.div(_templateObject5 || (_templateObject5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  @media (min-width: 600px) {\n    padding: 16px 56px 48px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    & > :not(:first-child) {\n      margin-left: 16px;\n    }\n  }\n\n  @media (max-width: 599px) {\n    padding: 16px 24px 32px;\n\n    & > * {\n      width: 100%;\n\n      &:not(:first-child) {\n        margin-top: 8px;\n      }\n    }\n  }\n"])));
var ButtonBase = /*#__PURE__*/styled(Button)(_templateObject6 || (_templateObject6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  && {\n    box-shadow: none;\n    border-radius: 10px;\n    padding: 9px 30px;\n\n    .MuiButton-label {\n      font-family: 'IBM Plex Sans', 'Helvetica Neue', Arial, sans-serif;\n      font-size: 14px;\n      line-height: 21px;\n    }\n\n    &:hover,\n    &:active {\n      box-shadow: none;\n    }\n  }\n"])));
var PrimaryButton = /*#__PURE__*/styled(ButtonBase)(_templateObject7 || (_templateObject7 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  && {\n    color: rgb(255, 255, 255);\n    border-color: #13144a;\n    background-color: #13144a;\n\n    .MuiButton-label {\n      color: rgb(255, 255, 255);\n    }\n\n    &:hover,\n    &:active {\n      border-color: #13144a;\n      background-color: #13144a;\n\n      .MuiButton-label {\n        color: rgb(255, 255, 255);\n      }\n    }\n  }\n"])));
var SecondaryButton = /*#__PURE__*/styled(ButtonBase)(_templateObject8 || (_templateObject8 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  && {\n    color: #13144a;\n    border: 2px solid #13144a;\n    background-color: transparent;\n    padding: 7px 28px;\n\n    .MuiButton-label {\n      color: #13144a;\n    }\n\n    &:hover,\n    &:active {\n      background-color: transparent;\n\n      .MuiButton-label {\n        color: #13144a;\n      }\n    }\n  }\n"])));
var SettingsContainer = /*#__PURE__*/styled.section(_templateObject9 || (_templateObject9 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  margin: 8px 0;\n  @media (min-width: 365px) {\n    display: grid;\n    grid-template-columns: 1fr auto;\n    column-gap: 8px;\n    row-gap: 22px;\n    align-items: start;\n  }\n"])));
var SettingHeading = /*#__PURE__*/styled.h1(_templateObject10 || (_templateObject10 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  font-size: 1.25rem;\n  font-family: 'GT Super', serif;\n  font-weight: 300;\n  line-height: 1;\n  color: #161710;\n  margin: 0;\n  padding-top: 10px;\n"])));
var SettingDescription = /*#__PURE__*/styled.p(_templateObject11 || (_templateObject11 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  color: #161710;\n  margin: 8px 0 0;\n"])));
var PinkSwitch = /*#__PURE__*/styled(Switch)(_templateObject12 || (_templateObject12 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  && {\n    .Mui-checked.Mui-disabled {\n      color: rgb(242, 138, 253);\n    }\n\n    .Mui-checked {\n      color: rgb(215, 22, 235);\n\n      & + .MuiSwitch-track {\n        background-color: rgb(215, 22, 235);\n      }\n    }\n  }\n"])));

var ConsentCookieNameV1 = 'cookieconsent_status';
var ConsentCookieNameV2 = 'cookieconsent_status_v2';
var PrivacyPolicyLink = 'https://tillitinvest.com/privacy';
var CookieDomain = '.tillitinvest.com';
function CookieConsent(_ref) {
  var onAllowed = _ref.onAllowed,
      onPreferencesChanged = _ref.onPreferencesChanged,
      exceptOnPaths = _ref.exceptOnPaths;

  var _useState = useState(false),
      open = _useState[0],
      setOpen = _useState[1];

  var _useState2 = useState('info'),
      page = _useState2[0],
      setPage = _useState2[1];

  useEffect(function () {
    var savedPreferences = getSavedPreferences();

    if (savedPreferences === null && !(exceptOnPaths != null && exceptOnPaths.includes(location.pathname))) {
      setOpen(true);
    }

    if (savedPreferences != null && savedPreferences.allowPerformanceCookies) {
      // Legacy support
      onAllowed == null ? void 0 : onAllowed();
    }

    if (savedPreferences) {
      onPreferencesChanged == null ? void 0 : onPreferencesChanged(savedPreferences);
    }
  }, []);

  var getSavedPreferences = function getSavedPreferences() {
    var v2Status = Cookies.get(ConsentCookieNameV2);

    if (v2Status) {
      return JSON.parse(v2Status);
    }

    var v1Status = Cookies.get(ConsentCookieNameV1);

    if (v1Status === undefined) {
      return null;
    }

    return {
      allowPerformanceCookies: v1Status === 'allow',
      allowTrackingCookies: false
    };
  };

  var setV1Cookie = function setV1Cookie(prefs, cookieOpts) {
    Cookies.set(ConsentCookieNameV1, prefs.allowPerformanceCookies ? 'allow' : 'deny', cookieOpts);
  };

  var handleSave = function handleSave(prefs) {
    var cookieOpts = {
      expires: 365,
      sameSite: 'Lax',
      secure: false,
      domain: CookieDomain
    };
    var payload = JSON.stringify(prefs); // Legacy support so that consent expressed through this dialog still allows any code using older
    // versions of the popup to see the correct enabled state and not re-show the dialog

    setV1Cookie(prefs, cookieOpts);
    Cookies.set(ConsentCookieNameV2, payload, cookieOpts); // Legacy support for the onAllowed prop, which only really considered performance cookies
    // (so we'll only fire that callback if performance cookie have been opted-into).

    if (prefs.allowPerformanceCookies) {
      onAllowed == null ? void 0 : onAllowed();
    }

    onPreferencesChanged == null ? void 0 : onPreferencesChanged(prefs);
    setOpen(false);
  };

  var currentPage;

  switch (page) {
    case 'info':
      currentPage = React.createElement(CookieInfo, {
        onManageSettings: function onManageSettings() {
          return setPage('settings');
        },
        onAccept: function onAccept() {
          return handleSave({
            allowPerformanceCookies: true,
            allowTrackingCookies: true
          });
        }
      });
      break;

    case 'settings':
      currentPage = React.createElement(CookieSettings, {
        onCancel: function onCancel() {
          return setPage('info');
        },
        onSave: handleSave
      });
      break;
  }

  return React.createElement(ConsentDialog, {
    open: open,
    // disableBackdropClick
    disableEscapeKeyDown: true,
    "aria-labelledby": "cookie-consent-dialog-title",
    maxWidth: "sm",
    fullWidth: true,
    scroll: "body"
  }, React.createElement(DialogHeading, {
    id: "cookie-consent-dialog-title"
  }, "Cookie consent"), currentPage);
}

function CookieInfo(_ref2) {
  var onManageSettings = _ref2.onManageSettings,
      onAccept = _ref2.onAccept;
  return React.createElement(React.Fragment, null, React.createElement(DialogContent, null, React.createElement(DialogCopy, null, "We use cookies to ensure you get the best experience while using TILLIT. You can find out more in our", ' ', React.createElement(Link, {
    href: PrivacyPolicyLink,
    target: "_blank"
  }, "Privacy policy"), ".")), React.createElement(StackMobileActions, null, React.createElement(SecondaryButton, {
    onClick: function onClick() {
      return onManageSettings();
    }
  }, "Manage settings"), React.createElement(PrimaryButton, {
    onClick: function onClick() {
      return onAccept();
    }
  }, "Accept")));
}

function CookieSettings(_ref3) {
  var onCancel = _ref3.onCancel,
      onSave = _ref3.onSave;

  var _useState3 = useState(false),
      allowPerformanceCookies = _useState3[0],
      setAllowPerformanceCookies = _useState3[1];

  var _useState4 = useState(false),
      allowTrackingCookies = _useState4[0],
      setAllowTrackingCookies = _useState4[1];

  return React.createElement(React.Fragment, null, React.createElement(DialogContent, null, React.createElement(SettingsContainer, null, React.createElement("div", null, React.createElement(SettingHeading, null, "Essential cookies"), React.createElement(SettingDescription, null, "These cookies are essential to operate TILLIT, including letting you log in and use the platform. These cannot be changed.")), React.createElement(PinkSwitch, {
    checked: true,
    disabled: true
  }), React.createElement("div", null, React.createElement(SettingHeading, null, "Analytical and performance cookies"), React.createElement(SettingDescription, null, "These cookies help ensure that you get the best possible experience while using TILLIT. They allow us to recognise how visitors move around on TILLIT and help inform which features to develop to improve your experience.")), React.createElement(PinkSwitch, {
    checked: allowPerformanceCookies,
    onChange: function onChange(e) {
      return setAllowPerformanceCookies(e.target.checked);
    }
  }), React.createElement("div", null, React.createElement(SettingHeading, null, "Marketing and tracking cookies"), React.createElement(SettingDescription, null, "These cookies allow TILLIT to monitor the effectiveness of our advertising campaigns and to customise advertisements for visitors to our website.")), React.createElement(PinkSwitch, {
    checked: allowTrackingCookies,
    onChange: function onChange(e) {
      return setAllowTrackingCookies(e.target.checked);
    }
  }))), React.createElement(StackMobileActions, null, React.createElement(SecondaryButton, {
    onClick: function onClick() {
      return onCancel();
    }
  }, "Cancel"), React.createElement(PrimaryButton, {
    onClick: function onClick() {
      return onSave({
        allowPerformanceCookies: allowPerformanceCookies,
        allowTrackingCookies: allowTrackingCookies
      });
    }
  }, "Save my preferences")));
}

function renderCookieConsentDialog(container, onAllowed, exceptOnPaths, onPreferencesChanged) {
  ReactDOM.render(React.createElement(CookieConsent, {
    onAllowed: onAllowed,
    exceptOnPaths: exceptOnPaths,
    onPreferencesChanged: onPreferencesChanged
  }), container);
}

export { CookieConsent, renderCookieConsentDialog };
//# sourceMappingURL=cookie-consent.esm.js.map
